import React, { useState } from 'react';
import { sanitiseHTML } from 'src/legacy/utils/helpers';
import Tooltip from 'src/components/base/Tooltip/Tooltip';
import EditButton from '../../../../../containers/TherapistProfile/Tabs/EditButton';
import { SectionChipsColors } from './sections';
import { ViewMoreActionButton, Typography } from 'src/latest/src/components';

interface Prop {
  label?: string;
  value: any;
  mergedData: any[];
  showPage: any;
  frontendIdentifier?: string;
  showAllAtOnce?: boolean;
}

export const TherapistSelections: React.FC<Prop> = ({
  label,
  value,
  mergedData,
  showPage,
  frontendIdentifier,
  showAllAtOnce = false,
}) => {
  const [showAll, setShowAll] = useState(showAllAtOnce);
  const renderData = showAll ? mergedData : mergedData?.slice(0, 3);

  return (
    <>
      {showPage && <EditButton section={value} showPage={showPage} />}

      {label && (
        <Typography
          variant="size-14"
          weight="bold"
          color="color-28"
          className="text-uppercase mb-4"
        >
          {label}
        </Typography>
      )}

      {mergedData && mergedData.length > 0 ? (
        <>
          <div className="expertisewrap pb-24">
            {renderData?.map((choice: any, index: any) => {
              const textValue =
                choice.display_title || choice.title || choice.value;

              return (
                <React.Fragment key={index}>
                  {textValue && textValue.length > 26 ? (
                    <Tooltip
                      text={textValue}
                      placement="top"
                      force={true}
                      className="concernstootip"
                    >
                      <div
                        className="wrapper-class"
                        style={{
                          backgroundColor:
                            SectionChipsColors[
                              frontendIdentifier || value?.frontend_identifier
                            ],
                        }}
                      >
                        <Typography
                          variant={`size-16`}
                          weight={`regular`}
                          color="color-2"
                        >
                          {sanitiseHTML(`${textValue.substring(0, 26)}...`)}
                        </Typography>
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      className="wrapper-class"
                      style={{
                        backgroundColor:
                          SectionChipsColors[
                            frontendIdentifier || value?.frontend_identifier
                          ],
                      }}
                    >
                      <Typography
                        variant={`size-16`}
                        weight={`regular`}
                        color="color-2"
                      >
                        {sanitiseHTML(textValue)}
                      </Typography>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {(mergedData.length > 3 && !showAllAtOnce) && (
            <ViewMoreActionButton showAll={showAll} setShowAll={setShowAll} />
          )}
        </>
      ) : (
        <Typography className='pb-24' variant="size-16" weight="regular" 
         color="color-2">
          N/A
        </Typography>
      )}
    </>
  );
};
